<template>
  <div style="margin-bottom: 2rem; text-align: left; position: relative">
    <div
      v-if="editing"
      style="
        display: flex;
        flex-direction: row;
        justify-content: start;
        margin-bottom: 20px;
      "
    >
      <div
        class="input-group"
        style="max-width: 200px; border-radius: 1rem; margin: 0"
      >
        <input
          v-model="selectedQuantity"
          type="number"
          min="1"
          max="50"
          step="1"
          class="form-control"
          style="border-radius: 1rem 0 0 1rem"
        />
        <span class="input-group-btn">
          <button
            class="btn btn-sm btn-primary"
            type="button"
            @click="updateQuantity"
          >
            Update
          </button>
        </span>
      </div>
      <button
        class="item-quantity-button btn btn-secondary"
        type="button"
        style="margin-left: 0.5rem"
        @click="editing = !editing"
      >
        <small>Cancel</small>
      </button>
    </div>
    <div v-else style="padding: 1px 0; margin-bottom: 20px">
      <span style="margin-right: 1rem">
        <b>Qty: {{ selectedQuantity }}</b>
      </span>
      <div class="btn-group" role="group" aria-label="Edit shopping cart item">
        <button
          class="item-quantity-button btn btn-outline-primary"
          type="button"
          @click="editing = !editing"
        >
          <small>Edit</small>
        </button>
        <button
          class="item-quantity-button btn btn-primary"
          type="button"
          style="border: 1px solid #d16c00"
          @click="handleDelete"
        >
          <small>Delete</small>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    quantity: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selectedQuantity: null,
      editing: false,
      selectY: null,
    };
  },
  beforeMount() {
    this.selectedQuantity = this.quantity;
  },
  methods: {
    updateQuantity() {
      this.editing = !this.editing;
      this.$emit("quantityUpdated", this.selectedQuantity);
    },
    handleDelete() {
      this.$emit("deleteItem");
    },
    hideSelect() {
      this.editing = false;
    },
  },
};
</script>

<style scoped>
.btn-outline-primary {
  border: 1px solid #d16c00 !important;
  color: #d16c00;
  background: none;
}

.btn-outline-primary:hover {
  border: 1px solid #d16c00;
  background: #f5e1cc;
}

.item-quantity-button {
  padding: 0.5rem 1rem;
}

.item-quantity-select {
  position: fixed;
  background: #ffffff;
  border: 1px solid #666666;
  border-radius: 0.5rem;
  padding: 0.5rem 0;
  z-index: 100;
}

.item-quantity-select ul {
  display: flex;
  flex-direction: column;
  list-style-type: none;
  margin: 0;
  margin-block-start: 0;
  margin-block-end: 0;
  padding: 0;
}

.item-quantity-select ul li {
  display: block;
}

.item-quantity-select a {
  padding: 0.5rem 1rem;
  display: block;
}

.item-quantity-select a:hover {
  background-color: #eeeeee;
}
</style>
